var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-loading"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.5 9L11.0669 15.8063C10.8229 16.0646 10.4271 16.0646 10.1831 15.8063L7.5 12.9676M7 21.5284C5.49963 20.6605 4.22328 19.4484 3.27893 18M7 2.4716C5.49963 3.33952 4.22328 4.55165 3.27893 6M1.78533 14.5C1.59868 13.6969 1.5 12.8599 1.5 12C1.5 11.1401 1.59868 10.3031 1.78533 9.5M10.5 1.18138C11.1486 1.06225 11.817 1 12.5 1C18.5751 1 23.5 5.92487 23.5 12C23.5 18.0751 18.5751 23 12.5 23C11.817 23 11.1486 22.9378 10.5 22.8186",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckLoading);
export default __webpack_public_path__ + "static/media/check-loading.93ef1c307583b6110fa50c5e77ab3512.svg";
export { ForwardRef as ReactComponent };